import { React, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Modal, Divider } from "semantic-ui-react";
import Checkbox from "@mui/material/Checkbox";
import { Checkbox as SemanticCheckbox } from "semantic-ui-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { set } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import Chip from "@mui/material/Chip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import TextField from "@mui/material/TextField";
function Settings() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
      first_name: "",
      last_name: "",
      organization_name: "",
      organization_short_name: "",
      organization_phone_no: "",
      organization_address: "",
      organization_city: "",
      organization_country: "",
      organization_postal_code: "",
      logo_url: "",
    });
    const [openCropper, setOpenCropper] = useState(false);
    const [image, setImage] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    const cropperRef = useRef(null);
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [passwords, setPasswords] = useState({
        current_password: "",
        new_password: ""
    });

    const handleChangePasswordClick = () => {
        setOpenPasswordModal(true);
    };

    const handleChangePasswordField = (e) => {
        setPasswords({
            ...passwords,
            [e.target.name]: e.target.value
        });
    };

    const handlePasswordSubmit = async () => {
        const response = await fetch(`${BASE_URL}/auth/change_password`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
            body: JSON.stringify(passwords),
        });
        const result = await response.json();
        if (result.success) {
            toast.success("Password changed successfully");
            setOpenPasswordModal(false);
        } else {
            toast.error(result.error);
        }
    };
    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    };
  
    const handleSubmit = async () => {
      const response = await fetch(`${BASE_URL}/auth/edit_organization_info`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      if (result.success) {
        toast.success("Organization updated successfully");
        getOrganization();
      } else {
        toast.error(result.error);
      }
    };
    const getOrganization = async () => {
      const response = await fetch(`${BASE_URL}/auth/get_organization_info`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      let data = await response.json();
      data = data.organization;
      setFormData({
        ...formData,
        first_name: data.first_name,
        last_name: data.last_name,
        organization_name: data.organization_name,
        organization_short_name: data.organization_short_name,
        organization_phone_no: data.organization_phone_no,
        organization_address: data.organization_address,
        organization_city: data.organization_city,
        organization_country: data.organization_country,
        organization_postal_code: data.organization_postal_code,
        logo_url: data.logo_url,
      });
    };

  // Open file input when pencil button is clicked
  const handleImageUploadClick = () => {
    document.getElementById('imageUploadInput').click();
  };

  // Handle image selection and open Cropper modal
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setOpenCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle image cropping
  const handleCrop = () => {
    const cropper = cropperRef.current.cropper;
    const croppedDataUrl = cropper.getCroppedCanvas().toDataURL();
    setFormData({
      ...formData,
      logo_url: croppedDataUrl,
    });
    setOpenCropper(false); // Close the modal
  };
    useEffect(() => {
      getOrganization();
    },[])
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <ToastContainer />
        <div className="container-fluid">
        {/* Change Password Button */}
        <Button variant="outlined" style={{ marginBottom: "20px", color: "#3f51b5" }} onClick={handleChangePasswordClick}>
                    Change Password
                </Button>
        <div className="row">
          <div className="col-md-9 mt-5">
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="First Name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Organization Name"
                    name="organization_name"
                    value={formData.organization_name}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Organization Short Name"
                    name="organization_short_name"
                    value={formData.organization_short_name}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Organization Phone Number"
                    name="organization_phone_no"
                    value={formData.organization_phone_no}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Organization Address"
                    name="organization_address"
                    value={formData.organization_address}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="City"
                    name="organization_city"
                    value={formData.organization_city}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Country"
                    name="organization_country"
                    value={formData.organization_country}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Postal Code"
                    name="organization_postal_code"
                    value={formData.organization_postal_code}
                    onChange={handleChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={11}>
                </Grid>
                <Grid item xs={1}>
                <Button variant="outlined" style={
                    {
                      color: "#3f51b5"
                    }
                } sx={{ mt: 3}}
                onClick={handleSubmit}
                >
                Save
              </Button>
                </Grid>
              </Grid>
              
            </form>
          </div>
          <div className="col-md-3 mt-5">
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
              src= {formData.logo_url || "/your_logo_here.png"}
                style={{
                  width: "90%",
                }}
              />
              <IconButton
                style={{
                  position: "absolute",
                  bottom: "0",
                  right: "0",
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  padding: "5px",
                }}
                onClick={handleImageUploadClick}
              >
                <EditIcon />
              </IconButton>
              <input
                id="imageUploadInput"
                type="file"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleImageChange}
              />
            </div>
          </div>
        </div>
                {/* Cropper Modal */}
                <Dialog open={openCropper} onClose={() => setOpenCropper(false)} fullWidth maxWidth="sm">
          <DialogContent>
            {image && (
              <Cropper
                src={image}
                style={{ height: 400, width: "100%" }}
                initialAspectRatio={16 / 9}
                guides={false}
                ref={cropperRef}
                viewMode={1}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenCropper(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleCrop} color="primary">
              Crop
            </Button>
          </DialogActions>
        </Dialog>
        {/* Password Change Modal */}
        <Dialog open={openPasswordModal} onClose={() => setOpenPasswordModal(false)}>
                    <DialogTitle>Change Password</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Current Password"
                            name="current_password"
                            type="password"
                            fullWidth
                            variant="outlined"
                            value={passwords.current_password}
                            onChange={handleChangePasswordField}
                        />
                        <TextField
                            margin="dense"
                            label="New Password"
                            name="new_password"
                            type="password"
                            fullWidth
                            variant="outlined"
                            value={passwords.new_password}
                            onChange={handleChangePasswordField}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenPasswordModal(false)} color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={handlePasswordSubmit} color="primary">
                            Change Password
                        </Button>
                    </DialogActions>
                </Dialog>
        </div>
      </DashboardLayout>
    );
  }
  
  export default Settings;
